import { render } from "./SuggestionList.vue?vue&type=template&id=b17f735a&scoped=true&bindings={\"suggestion\":\"props\",\"correctAnswer\":\"props\",\"selectedAnswer\":\"props\",\"nextButtonClicked\":\"props\",\"selectAnswer\":\"setup\",\"isAnswerWrong\":\"setup\",\"isAnswerCorrect\":\"setup\"}"
import script from "./SuggestionList.vue?vue&type=script&lang=js"
export * from "./SuggestionList.vue?vue&type=script&lang=js"

import "./SuggestionList.vue?vue&type=style&index=0&id=b17f735a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b17f735a"

export default script